import React, { Component } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { Helmet } from 'react-helmet';

class Badges extends Component {
  constructor(props) {
    super(props);
    this.state = { definitions: [], loading: true, rechecking: false, recheckResult: null };
    this._recheckUnsub = null;
  }

  componentDidMount() {
    firebase.firestore().collection('badgeDefinitions').get().then(snap => {
      const definitions = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      this.setState({ definitions, loading: false });
    }).catch(() => this.setState({ loading: false }));
  }

  componentWillUnmount() {
    if (this._recheckUnsub) { this._recheckUnsub(); this._recheckUnsub = null; }
  }

  handleRecheckAll = async () => {
    if (!window.confirm('Re-check all users against the current badge rules?\n\nThis can take several minutes for large user bases.')) return;
    this.setState({ rechecking: true, recheckResult: null });
    try {
      const ref = await firebase.firestore().collection('adminActions').add({
        type: 'recheckAll',
        status: 'pending',
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      });
      this._recheckUnsub = ref.onSnapshot((snap) => {
        const data = snap.data();
        if (!data) return;
        if (data.status === 'done') {
          this.setState({
            rechecking: false,
            recheckResult: `Done: checked ${data.checked} users, awarded ${data.awarded} badge(s).`,
          });
          this._recheckUnsub(); this._recheckUnsub = null;
        } else if (data.status === 'error') {
          this.setState({
            rechecking: false,
            recheckResult: `Error: ${data.error || 'Unknown error'}`,
          });
          this._recheckUnsub(); this._recheckUnsub = null;
        }
      });
    } catch (err) {
      this.setState({ rechecking: false, recheckResult: `Error: ${err.message}` });
    }
  };

  render() {
    const { definitions, loading, rechecking, recheckResult } = this.state;
    return (
      <div>
        <Helmet><title>Badges — BarZone</title></Helmet>
        <div style={{ padding: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
            <h2 style={{ margin: 0, color: '#111' }}>Badges</h2>
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                className="yellowBtn"
                style={{ background: rechecking ? '#aaa' : undefined }}
                onClick={this.handleRecheckAll}
                disabled={rechecking}
              >
                {rechecking ? 'Checking…' : '⟳ Re-check all users'}
              </button>
              <button className="yellowBtn" onClick={() => this.props.history.push('/badges/new')}>+ New Badge</button>
            </div>
          </div>
          {recheckResult && (
            <div style={{ marginBottom: 16, padding: '10px 14px', background: recheckResult.startsWith('Error') ? '#fdecea' : '#e8f5e9', borderRadius: 6, color: recheckResult.startsWith('Error') ? '#c62828' : '#2e7d32', fontSize: 14 }}>
              {recheckResult}
            </div>
          )}
          {loading ? <p style={{ color: '#666' }}>Loading...</p> : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  {['Key', 'Family', 'Metric', 'Active', 'Levels', 'Actions'].map(h => (
                    <th key={h} style={{ padding: '10px 12px', textAlign: 'left', borderBottom: '2px solid #ddd', fontSize: 13 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {definitions.map(def => (
                  <tr key={def.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={{ padding: '10px 12px', fontWeight: 600 }}>{def.key || def.id}</td>
                    <td style={{ padding: '10px 12px' }}>{def.family}</td>
                    <td style={{ padding: '10px 12px', fontSize: 12, color: '#666' }}>{def.metric}</td>
                    <td style={{ padding: '10px 12px' }}>
                      <span style={{ background: def.active ? '#2ecc71' : '#e74c3c', color: '#fff', borderRadius: 10, padding: '2px 8px', fontSize: 12 }}>
                        {def.active ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td style={{ padding: '10px 12px' }}>{def.levels ? def.levels.length : 0}</td>
                    <td style={{ padding: '10px 12px' }}>
                      <button className="yellowBtn" style={{ padding: '4px 14px', fontSize: 13 }} onClick={() => this.props.history.push('/badges/' + def.id)}>Edit</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {!loading && definitions.length === 0 && <p style={{ color: '#888', marginTop: 20 }}>No badge definitions yet.</p>}
        </div>
      </div>
    );
  }
}

export default Badges;
